import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';

export default function Advance({ children, attributes,clientId }) {
 
    const { mergedStyles, handleMouseEnter, handleMouseLeave,responsiveClasses, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);

    const blockProps = useBlockProps({
        className: `block-${clientId} ${hoverAnimationClass} ${responsiveClasses}`,
        style: {...mergedStyles,
             '--icon-size': attributes.iconsize?.Desktop, 
             '--icon-size-tablet': attributes.iconsize?.Tablet, 
             '--icon-size-mobile': attributes.iconsize?.Mobile,
             '--icon-alignment': attributes.iconalignment === 'left' ? 'inline-end' : 
                    attributes.iconalignment === 'right' ? 'inline-start' : 'center',

            },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });

    return (
        <div {...blockProps} >
            {children}
        </div>
    );
}